<template>
  <v-container>
    <h1>Résumé de votre Gaspillage Alimentaire</h1>
    <v-timeline align="center" dense>
      <v-timeline-item
        v-for="milestone in timelineItems"
        :key="milestone.id"
        :color="milestone.color"
        :icon="milestone.icon"
        :fill-dot="true"
      >
        <div class="timeline-label-wrapper">
          <span v-if="milestone.clickable" class="clickable-milestone-label" @click="onMilestoneClick(milestone)">
            {{ milestone.label }}
          </span>
          <span v-else class="milestone-label">{{ milestone.label }}</span>
        </div>
      </v-timeline-item>
    </v-timeline>
    <v-divider class="my-8"></v-divider>
    <div class="swot-section">
      <h2>Analyse SWOT</h2>
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="swot-card strength" outlined>
            <v-card-title>Forces</v-card-title>
            <v-card-text>
              <ul>
                <li>Exemple de force 1</li>
                <li>Exemple de force 2</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="swot-card weakness" outlined>
            <v-card-title>Faiblesses</v-card-title>
            <v-card-text>
              <ul>
                <li>Exemple de faiblesse 1</li>
                <li>Exemple de faiblesse 2</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="swot-card opportunity" outlined>
            <v-card-title>Opportunités</v-card-title>
            <v-card-text>
              <ul>
                <li>Exemple d'opportunité 1</li>
                <li>Exemple d'opportunité 2</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="swot-card threat" outlined>
            <v-card-title>Menaces</v-card-title>
            <v-card-text>
              <ul>
                <li>Exemple de menace 1</li>
                <li>Exemple de menace 2</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "WasteDiagnosticResumePage",
  data() {
    return {
      timelineItems: [
        { id: 1, label: "Niveau 1 du Diagnostique", color: "green", icon: "mdi-food-apple", clickable: true },
        {
          id: 2,
          label: "Niveau 2 du Diagnostique",
          color: "orange",
          icon: "mdi-food-apple",
          clickable: false,
        },
        { id: 3, label: "Niveau 3 du Diagnostique", color: "red", icon: "mdi-food-apple", clickable: false },
      ],
    }
  },
  methods: {
    onMilestoneClick(milestone) {
      if (milestone.clickable && milestone.id === 1) {
        this.$router.push({ name: "WasteDiagnosticPage" })
      }
    },
  },
}
</script>

<style scoped>
.timeline-label-wrapper {
  display: flex;
  align-items: center;
  margin-left: 16px;
}
.milestone-label {
  margin-left: 8px;
  font-weight: 500;
}
.clickable-milestone-label {
  margin-left: 8px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  color: #1976d2;
}
.swot-section {
  margin-top: 48px;
}
.swot-card {
  min-height: 180px;
}
.strength {
  border-left: 5px solid #43a047;
}
.weakness {
  border-left: 5px solid #e53935;
}
.opportunity {
  border-left: 5px solid #1e88e5;
}
.threat {
  border-left: 5px solid #fbc02d;
}
</style>
